import { derivarPeriodo } from "../parseFecha";

// Parser puro de la factura PDF de Vedic Rishi Astro Solutions (suscripcion mensual "Daily Horoscopes
// API", facturada a MERINELL SpA / Chile, en USD) -> shape transversal
//   { folio, fecha, periodo, concepto, monto, moneda, unidades }
// La factura declara "All values are in USD" y el monto vive en "Total Amount Payable inclusive of
// GST tax ( ... )   $89.00". Obligatorios (throw, todo-o-nada): folio, fecha, monto. moneda se LEE
// (guard no-USD como LATAM). unidades/concepto van null (el concepto lo arma el hook con el molde
// "Vedic Rishi AAAA/MM"; no factura por conteo, es una suscripcion fija).

// La fecha "Date of Issue" viene como "DD Month, YYYY" en ingles (ej. "15 August, 2026"). parseFecha
// NO soporta ese formato (dia-primero + coma + mes ingles completo) y lo comparten los otros 9
// parsers -> la conversion se resuelve ACA con un mapa de meses en ingles, sin tocar parseFecha.
const MESES_EN = {
  january: 1,
  february: 2,
  march: 3,
  april: 4,
  may: 5,
  june: 6,
  july: 7,
  august: 8,
  september: 9,
  october: 10,
  november: 11,
  december: 12,
};

export const parsearVedicRishiDesdeTexto = (texto) => {
  // pdfjs mete espacios multiples -> normalizar a un solo espacio antes de anclar.
  const t = (texto || "").replace(/\s+/g, " ");

  // folio: "Invoice Number   INVST9147" -> INVST + digitos. Obligatorio.
  const mFolio = t.match(/Invoice Number\s+(INVST\d+)/);
  const folio = mFolio ? mFolio[1] : null;
  if (!folio) throw new Error("No se reconoce el formato de factura Vedic Rishi (falta Invoice Number INVST…)");

  // fecha: "Date of Issue   15 August, 2026" (DD Month, YYYY ingles). Obligatorio.
  const mFecha = t.match(/Date of Issue\s+(\d{1,2})\s+([A-Za-z]+),?\s+(\d{4})/);
  if (!mFecha) throw new Error("No se pudo leer la fecha (Date of Issue) de la factura Vedic Rishi");
  const mesNum = MESES_EN[mFecha[2].toLowerCase()];
  if (!mesNum) throw new Error(`Mes no reconocido en la fecha de Vedic Rishi (${mFecha[2]})`);
  const fecha = `${mFecha[3]}-${String(mesNum).padStart(2, "0")}-${String(Number(mFecha[1])).padStart(2, "0")}`;

  // moneda: la factura declara "All values are in USD". Se LEE (no se asume); guard no-USD como LATAM.
  const mMoneda = t.match(/All values are in\s+([A-Z]{3})/);
  if (!mMoneda) throw new Error("No se pudo leer la moneda de la factura Vedic Rishi");
  const moneda = mMoneda[1];
  if (moneda !== "USD") throw new Error(`Factura Vedic Rishi no-USD (${moneda}), formato no soportado todavia`);

  // monto: "Total Amount Payable inclusive of GST tax ( SGST / UGST / CGST / IGST )   $89.00".
  // El [^$]* salta el parentesico intermedio hasta el primer "$" (el total a pagar). Obligatorio.
  const mMonto = t.match(/Total Amount Payable inclusive of GST tax[^$]*\$\s*([\d,]+\.\d{2})/);
  if (!mMonto) throw new Error("No se pudo leer el Total Amount Payable de la factura Vedic Rishi");
  const monto = Number(mMonto[1].replace(/,/g, ""));
  if (!monto || Number.isNaN(monto)) throw new Error("No se pudo leer el monto de la factura Vedic Rishi");

  return { folio, fecha, periodo: derivarPeriodo(fecha), concepto: null, monto, moneda, unidades: null };
};
